module.exports = __WEBPACK_EXTERNAL_MODULE__reactodia_worker_proxy_bfb14e3e__;